import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import * as Actions from '../loginActions';
import stateReady from 'assets/img/state-ready.svg';
import './styles.scss';

class Welcome extends Component {
  clearError = () => {
    this.props.addLoginData({ loading: {} });
    this.context.router.push('login');
  }

  render() {
    return (
      <div className='Unauthorized'>
        <img src={stateReady} alt='image ready' />
        <h2 className='Unauthorized__success'>¡Todo listo!</h2>
        <p>Tu cuenta esta activada y lista. Disfruta de Imobly.</p>
        <Button onClick={this.clearError} variant='contained' color='secondary'>iniciar sesión ahora</Button>
      </div>
    );
  }
}

Welcome.contextTypes = {
  router: PropTypes.shape()
};

Welcome.propTypes = {
  loginState: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);
const mapStateToProps = state => ({
  loginState: state.get('loginState'),
});

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);

